import { Text } from '@zinc/ui';

import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import Moment from 'moment';
import React from 'react';

@inject('vm')
@observer
class Subtitle extends React.Component {
  render() {
    if (!this.show) return null;
    return (
      <Text color="neutral-faded" size="caption-2">
        {this.label}
      </Text>
    );
  }

  @computed
  get show() {
    let { status, report } = this.props.vm;
    return status === 'normal' && !!report && !!report.timeStamp;
  }

  @computed
  get label() {
    let { timeStamp } = this.props.vm.report;
    return new Moment(timeStamp).format('dddd Do MMMM YYYY [at] h:mma');
  }
}

export default Subtitle;
